module.exports = __webpack_public_path__ + "img/open-graph-img.25cbd73.jpg";